import React from 'react'
import { Container, Hero, HeroBody, Subtitle, Title } from 'bloomer'

import Head from '../components/head'
import Layout from '../components/layout'
import Zapier from '../components/zapier'

const Integrations = props => (
  <Layout>
    <Head
      author={'Route'}
      title={'Zapier Integration'}
      description={`Route's integration with Zapier opens up a world of possiblities for your commercial cleaning business.`}
      keywords={['Route', 'integrations', 'zapier']}
      {...props}
    />
    <Hero isColor={'light'} isSize={'medium'}>
      <HeroBody>
        <Container hasTextAlign={'centered'}>
          <Title isSize={1}>Route + Zapier</Title>
          <Subtitle isSize={4}>
            Route's integration with Zapier opens up a world of possiblities for your business.
          </Subtitle>
          <Zapier style={{ marginTop: '4rem' }} />
        </Container>
      </HeroBody>
    </Hero>
  </Layout>
)

export default Integrations
